export const TEXT={
    Registration:{
        en:"Registration",
        ar:"تسجيل"
    },
    Name:{
        en:"Name",
        ar:"الاسم"
    },
    Address:{
        en:"Address",
        ar:"العنوان"
    },
    Class:{
        en:"Class",
        ar:"الصف"
    },
    BirthDate:{
        en:"Birth Date",
        ar:"تاريخ الميلاد"
    },
    WhatsAppNumber:{
        en:"WhatsApp Number",
        ar:"رقم واتساب"
    },
    EmailAddress:{
        en:"Email Address",
        ar:"البريد الالكتروني"
    },
    Password:{
        en:"Password",
        ar:"كلمة المرور"
    },
    ConfirmPassword:{
        en:"Confirm Password",
        ar:"تأكيد كلمة المرور"
    },
    Location:{
        en:"Location",
        ar:"الموقع"
    },
    DateOfBirth:{
        en:"Date Of Birth",
        ar:"تاريخ الميلاد"
    },
    Gender:{
        en:"Gender",
        ar:"النوع"
    },
    Male:{
        en:"Male",
        ar:"ذكر"
    },
    Female:{
        en:"Female",
        ar:"انثى"
    },
    DontHaveAccount:{
        en:"Dont Have Account ?",
        ar:"ليس لديك حساب ؟"
    },
    Submit:{
        en:"Submit",
        ar:"ارسال"
    }
}

export default TEXT